var map = {
	"./FooterView": 35,
	"./FooterView.vue": 35,
	"./HeaderView": 36,
	"./HeaderView.vue": 36,
	"./ProductIntro": 37,
	"./ProductIntro.vue": 37,
	"./privacy_cn.txt": 175,
	"./privacy_en.txt": 176,
	"./userprotocol_cn.txt": 177,
	"./userprotocol_en.txt": 178
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;


//////////////////
// WEBPACK FOOTER
// ./src/components ^\.\/.*$
// module id = 81
// module chunks = 0